import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { resolveEquipmentPhotoUrl } from "@/lib/equipmentApi";

interface ProtocolPhotoGalleryProps {
  paths: string[];
  emptyLabel?: string;
}

export function ProtocolPhotoGallery({ paths, emptyLabel = "Brak zdjęć" }: ProtocolPhotoGalleryProps) {
  const [urls, setUrls] = useState<string[]>([]);
  const [preview, setPreview] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (paths.length === 0) {
      setUrls([]);
      return;
    }
    void Promise.all(paths.map((path) => resolveEquipmentPhotoUrl(path))).then((resolved) => {
      if (!cancelled) {
        setUrls(resolved.filter((url): url is string => Boolean(url)));
      }
    });
    return () => {
      cancelled = true;
    };
  }, [paths]);

  if (paths.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyLabel}</p>;
  }

  return (
    <>
      <div className="grid grid-cols-3 gap-2">
        {urls.map((url) => (
          <button
            key={url}
            type="button"
            className="aspect-square overflow-hidden rounded-md border bg-muted"
            onClick={() => setPreview(url)}
          >
            <img src={url} alt="Zdjęcie stanu przedmiotu" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
      {preview && (
        <button
          type="button"
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 p-4"
          onClick={() => setPreview(null)}
          aria-label="Zamknij podgląd"
        >
          <img
            src={preview}
            alt="Podgląd zdjęcia"
            className="max-h-[85vh] max-w-full rounded-md object-contain"
            onClick={(event) => event.stopPropagation()}
          />
          <span className="absolute right-4 top-4 rounded-full bg-background/90 p-2">
            <X className="h-4 w-4" />
          </span>
        </button>
      )}
    </>
  );
}
